<template>
    <a-modal v-model="visible" :title="$t('purchaseRequestTemplate.selectProducts')" width="70%" :footer="null"
        @cancel="close">
        <div>
            <input v-model.trim="search" ref="search" type="text"
                :placeholder="$t('purchaseRequestTemplate.searchPlaceholder')" class="form-control" />
            <div class="ts-mt-3 ts-border ts-border-gray-300 ts-p-3 ts-rounded">
                <ts-loading-banner :loading="loading">
                    <div class="max-h">
                        <table class="ts-w-full">
                            <thead>
                                <tr>
                                    <th style="width: 15%;">{{ $t('purchaseRequestTemplate.productGroup') }}</th>
                                    <th style="width: 15%;">{{ $t('purchaseRequestTemplate.barcode') }}</th>
                                    <th style="width: 30%;">{{ $t('purchaseRequestTemplate.productName') }}</th>
                                    <th style="width: 15%;">{{ $t('purchaseRequestTemplate.uom') }}</th>
                                    <th style="width: 15%;">{{ $t('purchaseRequestTemplate.quantity') }}</th>
                                    <th style="width: 6%;">{{ $t('purchaseRequestTemplate.unitPrice') }}</th>
                                    <th style="width: 4%;"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(product, index) in products" :key="index">
                                    <td>{{ product.pro_group_name_en }}</td>
                                    <td>{{ product.barcode }}</td>
                                    <td>{{ product.product_name_en }}</td>
                                    <td>
                                        <a-select v-model="product.uom_id"
                                            :options="getUnitOfMeasures(product.uom_cat_id)"
                                            option-filter-prop="children" class="ts-w-full"
                                            :placeholder="$t('select')"></a-select>
                                    </td>
                                    <td>
                                        <input type="number" class="form-control ts-text-center"
                                            v-model.number="product.quantity" min="1" />
                                    </td>
                                    <td>
                                        <input type="number" class="form-control ts-text-right"
                                            v-model.number="product.unit_price" min="0" step="0.01" />
                                    </td>
                                    <td class="ts-text-center">
                                        <button class="btn btn-sm btn-outline-primary rounded-pill px-3"
                                            @click.prevent="addItem(product)">
                                            <i class="fa fa-plus ts-mr-1"></i> {{ $t('add') }}
                                        </button>
                                    </td>
                                </tr>
                                <tr v-if="products.length === 0">
                                    <td colspan="7" class="ts-text-center ts-p-4 text-gray-500">
                                        {{ $t('purchaseRequestTemplate.noProductsFound') }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ts-loading-banner>
            </div>
        </div>
    </a-modal>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
    name: 'productList',
    props: ['value'],
    data() {
        return {
            loading: false,
            search: '',
            model: {},
            errors: new Errors(),
            visible: false
        }
    },
    computed: {
        ...mapState('purchaseRequest/template', ['formViewDatas']),
        products() {
            if (this.formViewDatas['products']) {
                // Get IDs of products already added to template
                const addedProductIds = this.model.details.map(d => d.product_id);

                return this.formViewDatas['products']
                    .filter(
                        ei => {
                            // First exclude products already in the list
                            if (addedProductIds.includes(ei.product_id)) {
                                return false;
                            }

                            // Then apply search filter
                            return (this.search
                                .split(' ')
                                .every(s =>
                                    ei.barcode.toLowerCase().includes(s.toLowerCase())
                                ) ||
                                this.search
                                    .split(' ')
                                    .every(s =>
                                        ei.product_name_en.toLowerCase().includes(s.toLowerCase())
                                    ))
                        }
                    )
                    .slice(0, 20)
            }
            return []
        },
        unitOfMeasures() {
            if (this.formViewDatas['unitOfMeasures']) {
                return this.formViewDatas['unitOfMeasures'].map(el => ({
                    value: el.uom_id,
                    label: el.uom_name_en,
                    uom_cat_id: el.uom_cat_id,
                    is_default: el.is_default
                }))
            }
            return []
        }
    },
    created() {
        this.model = this.value
    },
    methods: {
        show() {
            this.visible = true;
            this.search = '';
        },
        close() {
            this.visible = false;
        },
        getUnitOfMeasures(uom_cat_id) {
            return this.unitOfMeasures.filter(el => el.uom_cat_id == uom_cat_id)
        },
        addItem(product) {
            if (!product.uom_id) {
                this.$message.warning(this.$t('purchaseRequestTemplate.pleaseSelectUom'))
                return
            }

            let row = {
                product_id: product.product_id,
                uom_id: product.uom_id,
                quantity: product.quantity ? product.quantity : 1,
                unit_price: product.unit_price ? product.unit_price : 0,
                remarks: null
            }
            this.model.details.push(row)

            // Reset product quantity and unit price
            product.quantity = 1
            product.unit_price = 0

            this.$message.success(this.$t('purchaseRequestTemplate.itemAdded'))
        }
    }
}
</script>

<style scoped>
.max-h {
    min-height: 50vh;
    max-height: 50vh;
    overflow-y: scroll;
}

.form-control {
    height: 32px;
}

table {
    width: 100%;
}

table thead tr {
    border-width: 1px;
    z-index: 3;
    position: sticky;
    top: 0;
}

table thead tr th {
    white-space: nowrap;
    background-color: #edf2f7;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}

table tbody tr {
    cursor: pointer;
    border-width: 1px;
}

table tbody tr:hover {
    background-color: #e2e8f0;
}

table tbody tr td {
    white-space: nowrap;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    border-right-width: 1px;
}
</style>
